import { text } from '@pdfme/schemas';

const longTextSchema = {
  pdf: text.pdf,
  ui: text.ui,
  propPanel: {
    ...text.propPanel,
    defaultSchema: {
      ...text.propPanel.defaultSchema,
      type: 'longText',
    },
  },
};

export default longTextSchema;
